export const HOMEPAGE = process.env.REACT_APP_HOME_PAGE;

export const SECTIONS = {
	COLEGIO: '/el-colegio',
	ACTUALIDAD: '/actualidad',
	ACADEMIA_MATRITENSE: '/academia-matritense',
	INFORMACION: '/informacion',
	SERVICIOS: '/servicios',
};

export const REL = {
	COLEGIO: {
		PRESENTACION: 'presentacion',
		JUNTA_DIRECTIVA: 'organizacion/junta-directiva',
		DEPARTAMENTOS: 'organizacion/departamentos',
		NOTARIOS: 'organizacion/notarios',
		VISITA_VIRTUAL: 'visita-virtual',
	},
	ACTUALIDAD: {
		BY_CATEGORY: ':category',
		BY_POST: ':category/:post',
	},
	ACADEMIA_MATRITENSE: {
		HISTORIA: 'historia',
		PROGRAMACION_ACADEMICA: 'programacion-academica',
		HEMEROTECA: 'hemeroteca',
		CATALOGO: 'catalogo',
		CATALOGO_BY_CATEGORY: 'catalogo/:category',
		CATALOGO_BY_PRODUCT: 'catalogo/:category/:product',
		CATALOGO_SOLICITAR: 'catalogo/:category/:product/solicitar',
	},
	INFORMACION: {
		BUSCADOR_NOTARIOS: 'encuentra-tu-notario/buscador-notarios',
		LIBRE_ELECCION_NOTARIOS: 'encuentra-tu-notario/libre-eleccion-notarios',
		NOTARIOS_DE_GUARDIA: 'encuentra-tu-notario/notarios-de-guardia',
		ACADEMIA_OPOSITORES: 'academia-de-opositores',
		ORGANISMOS_INTERNACIONALES: 'organismos-internacionales',
		ENCUENTRA_ESCRITURA: 'encuentra-tu-escritura',
		NUEVAS_ACTUACIONES_NOTARIALES: 'nuevas-actuaciones-notariales',
		NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE: 'nuevas-actuaciones-notariales/:page',
		ENLACES_INTERES: 'enlaces-de-interes',
	},
	SERVICIOS: {
		LEGALIZACION_APOSTILLAS: 'legalizacion-y-apostillas',
		COPIAS_ARCHIVOS_PROTOCOLO: 'copias-de-archivos-de-protocolo',
		ATENCION_CIUDADANO: 'atencion-al-ciudadano',
		EXPEDIENTES_MATRIMONIALES: 'expedientes-matrimoniales',
		PORTAL_EMPLEO: 'portal-empleo',
		PORTAL_EMPLEO_BY_OFERTA: 'portal-empleo/oferta/:oferta',
	},
};

export const ROUTES = {
	HOME: '/',
	// El Colegio
	COLEGIO_BASE: SECTIONS.COLEGIO,
	COLEGIO_PRESENTACION: `${SECTIONS.COLEGIO}/${REL.COLEGIO.PRESENTACION}`,
	COLEGIO_JUNTA_DIRECTIVA: `${SECTIONS.COLEGIO}/${REL.COLEGIO.JUNTA_DIRECTIVA}`,
	COLEGIO_DEPARTAMENTOS: `${SECTIONS.COLEGIO}/${REL.COLEGIO.DEPARTAMENTOS}`,
	COLEGIO_NOTARIOS: `${SECTIONS.COLEGIO}/${REL.COLEGIO.NOTARIOS}`,
	COLEGIO_VISITA_VIRTUAL: `${SECTIONS.COLEGIO}/${REL.COLEGIO.VISITA_VIRTUAL}`,
	// Actualidad
	ACTUALIDAD: SECTIONS.ACTUALIDAD,
	ACTUALIDAD_BY_CATEGORY: `${SECTIONS.ACTUALIDAD}/${REL.ACTUALIDAD.BY_CATEGORY}`,
	ACTUALIDAD_BY_POST: `${SECTIONS.ACTUALIDAD}/${REL.ACTUALIDAD.BY_POST}`,

	// Academia Matritense
	ACADEMIA_MATRITENSE_BASE: SECTIONS.ACADEMIA_MATRITENSE,
	ACADEMIA_MATRITENSE_HISTORIA: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.HISTORIA}`,
	ACADEMIA_MATRITENSE_PROGRAMACION_ACADEMICA: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.PROGRAMACION_ACADEMICA}`,
	ACADEMIA_MATRITENSE_HEMEROTECA: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.HEMEROTECA}`,
	ACADEMIA_MATRITENSE_CATALOGO: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.CATALOGO}`,
	ACADEMIA_MATRITENSE_CATALOGO_BY_CATEGORY: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.CATALOGO_BY_CATEGORY}`,
	ACADEMIA_MATRITENSE_CATALOGO_BY_PRODUCT: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.CATALOGO_BY_PRODUCT}`,
	ACADEMIA_MATRITENSE_CATALOGO_SOLICITAR: `${SECTIONS.ACADEMIA_MATRITENSE}/${REL.ACADEMIA_MATRITENSE.CATALOGO_SOLICITAR}`,

	// Información
	INFORMACION_BASE: SECTIONS.INFORMACION,
	INFORMACION_BUSCADOR_NOTARIOS: `${SECTIONS.INFORMACION}/${REL.INFORMACION.BUSCADOR_NOTARIOS}`,
	INFORMACION_LIBRE_ELECCION_NOTARIOS: `${SECTIONS.INFORMACION}/${REL.INFORMACION.LIBRE_ELECCION_NOTARIOS}`,
	INFORMACION_NOTARIOS_DE_GUARDIA: `${SECTIONS.INFORMACION}/${REL.INFORMACION.NOTARIOS_DE_GUARDIA}`,
	INFORMACION_ACADEMIA_OPOSITORES: `${SECTIONS.INFORMACION}/${REL.INFORMACION.ACADEMIA_OPOSITORES}`,
	INFORMACION_ORGANISMOS_INTERNACIONALES: `${SECTIONS.INFORMACION}/${REL.INFORMACION.ORGANISMOS_INTERNACIONALES}`,
	INFORMACION_ENCUENTRA_ESCRITURA: `${SECTIONS.INFORMACION}/${REL.INFORMACION.ENCUENTRA_ESCRITURA}`,
	INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES: `${SECTIONS.INFORMACION}/${REL.INFORMACION.NUEVAS_ACTUACIONES_NOTARIALES}`,
	INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE: `${SECTIONS.INFORMACION}/${REL.INFORMACION.NUEVAS_ACTUACIONES_NOTARIALES_BY_PAGE}`,
	INFORMACION_ENLACES_INTERES: `${SECTIONS.INFORMACION}/${REL.INFORMACION.ENLACES_INTERES}`,

	// Servicios
	SERVICIOS_BASE: SECTIONS.SERVICIOS,
	SERVICIOS_LEGALIZACION_APOSTILLAS: `${SECTIONS.SERVICIOS}/${REL.SERVICIOS.LEGALIZACION_APOSTILLAS}`,
	SERVICIOS_COPIAS_ARCHIVOS_PROTOCOLO: `${SECTIONS.SERVICIOS}/${REL.SERVICIOS.COPIAS_ARCHIVOS_PROTOCOLO}`,
	SERVICIOS_ATENCION_CIUDADANO: `${SECTIONS.SERVICIOS}/${REL.SERVICIOS.ATENCION_CIUDADANO}`,
	SERVICIOS_EXPEDIENTES_MATRIMONIALES: `${SECTIONS.SERVICIOS}/${REL.SERVICIOS.EXPEDIENTES_MATRIMONIALES}`,
	SERVICIOS_PORTAL_EMPLEO: `${SECTIONS.SERVICIOS}/${REL.SERVICIOS.PORTAL_EMPLEO}`,
	SERVICIOS_PORTAL_EMPLEO_BY_OFERTA: `${SECTIONS.SERVICIOS}/${REL.SERVICIOS.PORTAL_EMPLEO_BY_OFERTA}`,
};
